
export class ListProgram {
    public Name: string;
    public Agency: string;
    public Address: string;
    public City: string;
    public Website: string;
    public Id: number;
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/common/list-program.ts